export default {
  "login": "Anirbansikder",
  "id": 65562060,
  "node_id": "MDQ6VXNlcjY1NTYyMDYw",
  "avatar_url": "https://avatars.githubusercontent.com/u/65562060?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/Anirbansikder",
  "html_url": "https://github.com/Anirbansikder",
  "followers_url": "https://api.github.com/users/Anirbansikder/followers",
  "following_url": "https://api.github.com/users/Anirbansikder/following{/other_user}",
  "gists_url": "https://api.github.com/users/Anirbansikder/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/Anirbansikder/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/Anirbansikder/subscriptions",
  "organizations_url": "https://api.github.com/users/Anirbansikder/orgs",
  "repos_url": "https://api.github.com/users/Anirbansikder/repos",
  "events_url": "https://api.github.com/users/Anirbansikder/events{/privacy}",
  "received_events_url": "https://api.github.com/users/Anirbansikder/received_events",
  "type": "User",
  "site_admin": false,
  "name": "Anirban Sikder",
  "company": null,
  "blog": "",
  "location": null,
  "email": null,
  "hireable": null,
  "bio": null,
  "twitter_username": null,
  "public_repos": 18,
  "public_gists": 0,
  "followers": 39,
  "following": 65,
  "created_at": "2020-05-18T17:53:23Z",
  "updated_at": "2022-04-11T03:23:29Z",
};
